// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployerTerminationPropertiesDto
 */
export interface IEmployerTerminationPropertiesDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployerTerminationPropertiesDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IEmployerTerminationPropertiesDto
     */
    organization_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IEmployerTerminationPropertiesDto
     */
    termination_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IEmployerTerminationPropertiesDto
     */
    coverage_end_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IEmployerTerminationPropertiesDto
     */
    claim_last_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployerTerminationPropertiesDto
     */
    bulk_transfer?: boolean;
}

/**
 * Check if a given object implements the IEmployerTerminationPropertiesDto interface.
 */
export function instanceOfIEmployerTerminationPropertiesDto(value: object): value is IEmployerTerminationPropertiesDto {
    return true;
}

export function IEmployerTerminationPropertiesDtoFromJSON(json: any): IEmployerTerminationPropertiesDto {
    return IEmployerTerminationPropertiesDtoFromJSONTyped(json, false);
}

export function IEmployerTerminationPropertiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployerTerminationPropertiesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'termination_date': json['termination_date'] == null ? undefined : (new Date(json['termination_date'])),
        'coverage_end_date': json['coverage_end_date'] == null ? undefined : (new Date(json['coverage_end_date'])),
        'claim_last_date': json['claim_last_date'] == null ? undefined : (new Date(json['claim_last_date'])),
        'bulk_transfer': json['bulk_transfer'] == null ? undefined : json['bulk_transfer'],
    };
}

export function IEmployerTerminationPropertiesDtoToJSON(json: any): IEmployerTerminationPropertiesDto {
    return IEmployerTerminationPropertiesDtoToJSONTyped(json, false);
}

export function IEmployerTerminationPropertiesDtoToJSONTyped(value?: IEmployerTerminationPropertiesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organization_id': value['organization_id'],
        'termination_date': value['termination_date'] == null ? undefined : ((value['termination_date']).toISOString()),
        'coverage_end_date': value['coverage_end_date'] == null ? undefined : ((value['coverage_end_date']).toISOString()),
        'claim_last_date': value['claim_last_date'] == null ? undefined : ((value['claim_last_date']).toISOString()),
        'bulk_transfer': value['bulk_transfer'],
    };
}

